import { EntDirectoryInfoName } from "../directoryInfoName";
import { EntLeasingItem } from "./leasingItem";

export class EntLeasingRegister {
  id: number | null = null;
  projectId: number | null = null;
  operatorId: number | null = null;
  issueDate: string | null = null;
  leaseTermYears: number | null = null;
  interestRate: number | null = null;
  territorialUnits: EntLeasingItem[] | null = null;
  operator: EntDirectoryInfoName | null = null;
  project: EntDirectoryInfoName | null = null;
}
